import {
  Module,
  VuexModule,
  Mutation,
  getModule,
  Action,
} from 'vuex-module-decorators';
import store from '@/store';
import EventBus, { Event } from '@/event.bus'
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import CompanyService from './business-unit.service';

@Module({
  dynamic: true,
  name: 'businessUnitStore',
  store,
  namespaced: true,
})
export class BusinessUnitStoreModule extends VuexModule {
  userBusinessUnits: Array<BusinessUnit> = [];

  selectedBusinessUnit: BusinessUnit = new BusinessUnit({});

  @Mutation
  setBusinessUnits(businessUnits: Array<BusinessUnit>) {
    this.userBusinessUnits = businessUnits;
  }

  @Mutation
  setSelectedBusinessUnit(businessUnit: BusinessUnit) {
    this.selectedBusinessUnit = businessUnit;
    EventBus.$emit(Event.BUSINESS_UNIT_SELECTED, this.selectedBusinessUnit)
    sessionStorage.setItem('selectedBusinessUnit', JSON.stringify(this.selectedBusinessUnit))
  }

  @Action({ commit: 'setBusinessUnits' })
  async initBusinessUnits(): Promise<BusinessUnit[]> {
    await this.setBusinessUnits
    return CompanyService.getAll();
  }

  @Action({ commit: 'setSelectedBusinessUnit' })
  async initSelectedBusinessUnit(): Promise<BusinessUnit> {
    await this.initBusinessUnits()
    return !this.selectedBusinessUnit.id
      ? this.setInitialBusinessUnit
      : this.selectedBusinessUnit;
  }

  get setInitialBusinessUnit() {
    const sessionBusinessUnit = sessionStorage.getItem('selectedBusinessUnit')
    return sessionBusinessUnit
      ? BusinessUnit.of(JSON.parse(sessionBusinessUnit))
      : this.userBusinessUnits[0]
  }

  get businessUnits(): BusinessUnit[] {
    return this.userBusinessUnits
  }

  get currentBusinessUnit() {
    return this.selectedBusinessUnit
  }
}

const BusinessUnitStore = (() => getModule(BusinessUnitStoreModule))();

export default BusinessUnitStore;
